import { resolveWidgetLanguage } from "./resolve-widget-language";

export const MANUAL_LANGUAGE_STORAGE_KEY = "baback:widget-language";

export function readManualLanguage(): string | null {
  return sessionStorage.getItem(MANUAL_LANGUAGE_STORAGE_KEY);
}

type WidgetLocation = Pick<Location, "hash" | "search">;

// The widget runs under a HashRouter, so its query normally lives inside the
// hash. A hand-written URL puts it before the hash instead, which is the shape
// a merchant testing a locale reaches for first.
function readQueryParam(location: WidgetLocation, name: string): string | null {
  const hashQuery = location.hash.split("?")[1] ?? "";
  return (
    new URLSearchParams(hashQuery).get(name) ??
    new URLSearchParams(location.search).get(name)
  );
}

/**
 * Language known before anything is fetched: the customer's own pick, `?lang=`,
 * then the storefront locale forwarded by the embed script. i18next starts on
 * it, so the first bundle downloaded is already the right one. The shop's
 * language list is unknown this early: `useWidgetLanguage` bounds the result to
 * it once the shop is loaded.
 */
export function readBootLanguage(
  location: WidgetLocation = window.location,
): string | undefined {
  return resolveWidgetLanguage(
    [
      { source: "manual", code: readManualLanguage() },
      { source: "url", code: readQueryParam(location, "lang") },
      { source: "storefront", code: readQueryParam(location, "storefrontLang") },
    ],
    [],
  )?.code;
}
